import { AlertDialog } from '../shared/components/alert-dialog';
import { Page, type PageProps } from '../shared/ui/page/page';
import { GlobalTopRightContent } from './GlobalTopRightContent';

export function DashboardPage({ children, topRight, ...props }: PageProps) {
  return (
    <Page
      {...props}
      topRight={<GlobalTopRightContent>{topRight}</GlobalTopRightContent>}
    >
      <AlertDialog
        alertType="actionless"
        headerText=""
        headerProps={{ pb: 0 }}
        bodyContent={<span></span>}
        buttonLoading={false}
        showCloseBtn={false}
        chakraAlertProps={{
          closeOnOverlayClick: true,
          motionPreset: 'slideInBottom',
          isCentered: true,
        }}
      />
      {children}
    </Page>
  );
}

export default DashboardPage;
